import $ from 'jquery';
import 'select2';

export const countryStateCity = () => {
  const $country = $('#country_id'),
    $state = $('#state_id'),
    $city = $('#city_id');

  $country
    .select2({
      theme: 'classic',
    })
    .on('change', function (e) {
      $.ajax({
        type: 'GET',
        url: `/pais/${$('#country_id').val()}/busca-estados`,
        data: {
          id: e.target.value,
          _token: $('meta[name="csrf-token"]').attr('content'),
        },
        cache: false,
        dataType: 'json',
      }).then(function (data) {
        console.log(data);
        $state.empty();

        $.each(data, function (index, element) {
          var option = new Option(element, index);
          $state.append(option);
        });
      });
    });

  $state.select2({
    theme: 'classic',
  });

  $state
    .select2({
      theme: 'classic',
    })
    .on('change', function (e) {
      $.ajax({
        type: 'GET',
        url: `/estados/busca-cidades/${$('#state_id').val()}`,
        data: {
          id: e.target.value,
          _token: $('meta[name="csrf-token"]').attr('content'),
        },
        cache: false,
        dataType: 'json',
      }).then(function (data) {
        $city.empty();

        $.each(data, function (index, element) {
          var option = new Option(element, index);
          $city.append(option);
        });
      });
    });

  $city.select2({
    theme: 'classic',
  });
};

export const companyUnity = () => {
  const $company = $('.js-companies'),
    $unity = $('.js-unities');

  $company
    .select2({
      theme: 'classic',
    })
    .on('change', function (e) {
      const val = e.target.value;

      if (val) {
        $unity.select2({
          theme: 'classic',
        });
      }

      $unity.prop('disabled', val ? false : true);

      if (val != 0 && val != '') {
        $.ajax({
          type: 'GET',
          url: `/empresas/busca-unidades/${val}`,
          data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
          },
          cache: false,
          dataType: 'json',
        }).then(function (data) {
          $unity.empty();

          $.each(data, function (index, element) {
            var option = new Option(element, index);
            $unity.append(option);
          });
        });
      }

    });

  $unity.select2({
    theme: 'classic',
  });
};

export const howKnowOther = () => {
  $('select[name="how_know"]').on('change', function (e) {
    if (e.target.value == 'Outro (especifique)') {
      $('#how_know_other').slideDown();
    } else {
      $('#how_know_other').slideUp();
    }
  });
};

export const areaOther = () => {
  $('select[name="area"]').on('change', function (e) {
    if (e.target.value == 'Outras (Descreva)') {
      $('#area_other').slideDown();
    } else {
      $('#area_other').slideUp();
    }
  });
};

export const selectChannel = () => {
  const $channel = $('.js-select-channel');
  const $otherChannel = $('.js-other-channel');
  const $otherChannelInput = $('input[name="channel_other"]');

  $channel
    .select2({
      theme: 'classic',
    })
    .on('change', function (e) {
      if (e.target.value === 'outro') {
        $otherChannel.show();
        $otherChannelInput.prop('required', true);
      } else {
        $otherChannel.hide();
        $otherChannelInput.val('').prop('required', false);
      }
    });
};
